export const inputStyle = {
  width: "100%",
  borderRadius: "0.6rem",
  border: "1px solid #f0801733",
  background: "#FFFFFF",
  padding: "0.55rem 0.8rem",
  fontSize: "0.9rem",
  color: "#241f33",
  outline: "none",
};
